import React, { useState, useEffect } from "react";
import { Card, Button, Row, Col, Table, Form } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import { SUB_METHOD, SUB_STATUS, SUB_TIER, SUB_TYPE } from "../../Const";
import PremiumInfo from "../subscription/PremiumInfo";
import FreeInfo from "../subscription/FreeInfo";
import { checkSub } from "../../utils/SubUtils";
import { capitalize, formatDate, milisecOf } from "../../utils/Utils";
import Switch from "react-switch";
import CustomPagination from "../common/CustomPagination";
import Loading from "../common/Loading";
import useLoading from "../hooks/useLoading";
import { toast } from "react-toastify";
import "./SubscriptionPanel.scss";

import {
  checkSubscription,
  cancelSubscription,
  continueSubscription,
} from "../../actions/setting-action";
import ConfirmCancelDialog from "./ConfirmCancelDialog";
import ContinueSubscriptionDialog from "./ContinueSubscriptionDialog";
import { useTranslation } from "react-i18next";

const SubscriptionPanel = (props) => {
  const { checkSubscription, cancelSubscription, continueSubscription } = props;
  const {t} = useTranslation()
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [showContinueDialog, setShowContinueDialog] = useState(false);
  const [isYearly, setIsYearly] = useState(true);
  
  const [startItem, setStartItem] = useState(0);
  const [setLoading, bindLoading] = useLoading(false);
  const itemPerPage = 5;
  const subscription = useSelector(
    (state) => state.auth.user.user_subscription
  );
  const {
    subMethod,
    subType,
    subPremium,
    subStatus,
    subEndDate,
    subInvoices,
    subDayLeft,
    subTier,
  } = checkSub(subscription);
  const [plan, setPlan] = useState("monthly");

  const showCancelBtn =
    subPremium &&
    [SUB_METHOD.stripe].includes(subMethod) &&
    subStatus == SUB_STATUS.active;

  subInvoices.sort((item1, item2) => {
    const date1 = item1.time;
    const date2 = item2.time;
    return milisecOf(date2) - milisecOf(date1);
  });

  const clickCancel = () => {
    setShowCancelDialog(false);
    setLoading(true);
    cancelSubscription()
      .then(() => {
        setLoading(false);
        toast.info(t("plan-cancelled"));
      })
      .catch((err) => {
        setLoading(false);
        toast.error(String(err));
      });
  };

  const clickContinue = () => {
    if (subStatus != SUB_STATUS.canceled) return;
    setShowContinueDialog(false);
    setLoading(true);
    continueSubscription()
      .then(() => {
        setLoading(false);
        toast.info(t("plan-continued"));
      })
      .catch((err) => {
        setLoading(false);
        toast.error(String(err));
      });
  };

  useEffect(() => {
    checkSubscription().then((res) => {});
  }, [checkSubscription]);

  useEffect(() => {
    if (subPremium) {
      setIsYearly(subType == SUB_TYPE.yearly);
    }
  }, [subPremium]);
  const changeStartItem= (electedExchangeId,itemsCountPerPage,num)=>{
    setStartItem(num)
  }
  const txs =
    subInvoices &&
    subInvoices.slice(startItem, startItem + itemPerPage).map((item, index) => {
      return (
        <tr key={index}>
          <td>{formatDate(item.time)}</td>
          <td>{item.txId}</td>
          <td>{item.amount}</td>
        </tr>
      );
    });

  return (
    <>
      <div className="sub-panel">
        <div className="round-bg my-plan">
          <h5 className="d-flex justify-content-between">
            {t("my-plan")}{" "}
            {showCancelBtn ? (
              <div className="d-inline mr-5">
                <Button
                  variant="outline-danger"
                  onClick={() => setShowCancelDialog(true)}
                >
                  {t("cancel-renewal")}
                </Button>
              </div>
            ) : (
              <></>
            )}
          </h5>
          <div className="row justify-content-between mt-3 sub-row">
            <Table responsive borderless className="text-left theme-bg">
              <thead>
                <tr>
                  <th>{t("curr-plan")}</th>
                  <th>{t("d-remain")}</th>
                  <th>{t("next-pay")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <h6>
                      {subPremium
                        ? capitalize(subTier) + " " + capitalize(subType)
                        : t("free")}
                    </h6>
                  </td>
                  <td>
                    <h6>{subDayLeft}</h6>
                  </td>
                  <td>
                    <h6
                      className={
                        subStatus == SUB_STATUS.canceled ? "text-danger" : ""
                      }
                    >
                      {subStatus == SUB_STATUS.canceled
                        ? t("cancelled")
                        : subEndDate}
                    </h6>
                  </td>
                </tr>
              </tbody>
            </Table>
            <a href="https://billing.stripe.com/p/login/9AQ00C81bd6EcF27ss" className="ml-2 mt-3 text-right w-100" target="_blank">Manage Payment Details</a>
          </div>
        </div>
        <div className="round-bg mt-3">
          <h5 className="sub-row">{t("sub-plans")}</h5> 
          <div className="row justify-content-center align-items-center mb-1 ">
          <a href="https://www.forexhero.ai/pricing" className="text-success " target="_blank">Current Month's Promotion</a>
          </div>
          <div className="row justify-content-center align-items-center mb-5">
            <h6 className="mr-3 d-line"></h6>
              {/* <Switch
                checkedIcon={false}
                uncheckedIcon={false}
                checked={isYearly}
                onChange={setIsYearly}
                offColor="#9381FF"
                onColor="#05CD99"
              /> */}
              <Form.Group
                    as={Row}
                    className="mt-2"
                    onChange={(e) => setPlan(e.target.value)}
                  >
                    <Form.Check
                      type="radio"
                      label={t("Monthly")}
                      name="plan"
                      value="monthly"
                      className="mr-3"
                      defaultChecked={true}
                    />
                    {/* <Form.Check
                      type="radio"
                      label="Quarterly"
                      name="plan"
                      value="quarterly"
                      className="mr-3"
                      defaultChecked={false}
                    /> */}
                    <Form.Check
                      type="radio"
                      label={t("yearly") +'(-21%)'} 
                      name="plan"
                      value="yearly"
                      className="mr-3"
                      defaultChecked={false}
                    />
                  </Form.Group>
            <h6 className="ml-3 d-line"></h6>
          </div>
          <Row className="sub-row text-center" noGutters>
            {/* <Col className="sub-col">
              <FreeInfo isPremium={subPremium} t={t} isYearly={isYearly}  tier={SUB_TIER.free}/>
            </Col> */}
            <Col className="sub-col">
              <PremiumInfo
                isYearly={isYearly}
                subStatus={subStatus}
                subPremium={subPremium}
                tier={SUB_TIER.lite}
                subTier={subTier}
                plan={plan}
                onUpgrade={() => setShowContinueDialog(true)}
                t={t}
              />
            </Col>
            <Col className="sub-col">
              <PremiumInfo
                isYearly={isYearly}
                subStatus={subStatus}
                subPremium={subPremium}
                tier={SUB_TIER.premium}
                subTier={subTier}
                plan={plan}
                onUpgrade={() => setShowContinueDialog(true)}
                t={t}
              />
            </Col>
            <Col className="sub-col">
              <PremiumInfo
                isYearly={isYearly}
                subStatus={subStatus}
                subPremium={subPremium}
                tier={SUB_TIER.pro}
                subTier={subTier}
                plan={plan}
                onUpgrade={() => setShowContinueDialog(true)}
                t={t}
              />
            </Col>
          </Row>
        </div>
        {txs != null && txs.length > 0 ? (
          <div className="sub-row">
            <h5>{t("payment-history")}</h5>
            <Table borderless responsive>
              <thead>
                <tr>
                  <th>{t("date")}</th>
                  <th>Tx ID</th>
                  <th>{t("price")}</th>
                </tr>
              </thead>
              <tbody>{txs}</tbody>
            </Table>
            <CustomPagination
              startItem={startItem}
              onChange={changeStartItem}
              itemsCountPerPage={itemPerPage}
              totalCount={subInvoices.length || 0}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      <ConfirmCancelDialog
        show={showCancelDialog}
        onHide={() => setShowCancelDialog(false)}
        confirmed={() => clickCancel()}
      />
      <ContinueSubscriptionDialog
        show={showContinueDialog}
        onHide={() => setShowContinueDialog(false)}
        confirmed={() => clickContinue()}
      />
      <Loading {...bindLoading} />
    </>
  );
};

export default connect(null, {
  checkSubscription,
  cancelSubscription,
  continueSubscription,
})(SubscriptionPanel);
